import React, { useContext } from 'react'
import { string } from 'prop-types'
import classNames from 'classnames'

import styles from './ChevronTitle.module.scss'

import Type from '@/component/Primitive/Type'
import Icon from '@/component/Primitive/Icon'
import { ThemeContext } from '@/component/Context/ThemeContext'

const ChevronTitle = ({ title, className, ...other }) => {
  const { brandType } = useContext(ThemeContext)
  return (
    <Type
      themed
      as="h2"
      className={classNames(styles.ChevronTitle, className)}
      size={['heading3', 'heading2']}
      weight="medium"
      {...other}
    >
      <Icon
        className={classNames(
          styles.ArrowIcon,
          brandType === 'Lifestyle' && styles.shiftDown
        )}
        type="arrow-right--double"
        width={20}
        height={17}
      />
      {title}
    </Type>
  )
}

ChevronTitle.propTypes = {
  title: string.isRequired,
  className: string
}

export default ChevronTitle
